<template>
    <div />
</template>

<script>
export default {
    name: "HasUnseenCommentsMarker"
}
</script>

<style scoped>
    div {
        background-color: #0758F3;
        width: 5px;
        height: 5px;
        border-radius: 5px;
    }
</style>